import React from 'react';
import { Purchase } from '../../components/meta';
import page from '../shared/qualify/page';
import PurchaseDashboard from './dashboard';

const Dashboard = (params) => <PurchaseDashboard {...params} />;

export default ({ path, actionPipe }) =>
  page({
    path,
    actionPipe,
    scenario: 'Purchase',
    Dashboard,
    meta: Purchase
  });



// WEBPACK FOOTER //
// ./src/products/purchase/index.js